import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { ForgeApp } from "./ForgeApp"
import "@repo/office-render/styles.css"

const root = document.getElementById("root")
if (!root) throw new Error("missing #root")

createRoot(root).render(
  <StrictMode>
    <ForgeApp />
  </StrictMode>,
)
